import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Rating from 'modules/core/components/Rating'

import { Element } from 'modules/forms/lib/Element'

import TextArea from '../../../core/components/TextArea'
import { Answer } from '../../lib/types'

interface RatingElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
}

/**
 * Editor component for TextElement
 */
export const RatingElementQuestion: React.FC<RatingElementQuestionProps> = ({
  element,
  onChange,
}) => {
  const [ratingValue, setRatingValue] = React.useState<number | null>(null) //TODO get current value
  const [commentValue, setCommentValue] = React.useState<string | undefined>() //TODO get current value

  const handleRatingChange = (value: number | null) => {
    setRatingValue(value)
    onChange?.({ answer: String(value) })
  }
  const handleCommentChange = (value: string | undefined) => {
    setCommentValue(value)
    onChange?.({ answer: String(value) })
  }

  const hasAttemptedSubmit = false // TODO

  const getError = () => {
    if (hasAttemptedSubmit) {
      if (element.mandatory && ratingValue === null) {
        return 'This field is required' // TODO Translate
      }
    }
    return undefined
  }
  const [hoveredRating, setHoveredRating] = React.useState<number | null>(null)
  const ratingLabels = element.options.reduce<Record<number, string>>((acc, item) => {
    const label = { [item.value]: `${item.value}. ${item.label}` }
    return { ...acc, ...label }
  }, {})

  const range = element.options.map((r) => Number(r.value))
  const min = Math.min(...range)
  const max = Math.max(...range)

  const optionalComment = element.getParam('optional_comment') ?? undefined
  return (
    <Box gap="s16">
      <Rating
        hasTooltip
        value={ratingValue}
        max={max}
        min={min}
        error={getError()}
        onClick={handleRatingChange}
        onHover={setHoveredRating}
        mandatory={element.mandatory}
        tooltipLabel={hoveredRating !== null ? ratingLabels[hoveredRating] : ''}
      />
      {optionalComment && (
        <TextArea
          hideLabel
          placeholder={'Add your question'} // TODO: Translate
          value={commentValue}
          onChange={handleCommentChange}
          // readonly={!onChange}
          error={getError()}
          minRows={element.getParam('rows')} // LongTextElement uses this param optionally, but it's not used by TextElement
        />
      )}
    </Box>
  )
}
